import { CollectionView } from 'marionette';
import BaseViewMixin from 'app/src/views/base/BaseViewMixin';

export default CollectionView.extend(BaseViewMixin);
